import React from 'react';
import { CategoryWithChildren } from './types';
import '../../../components/common/CRMList.css';
import './CategoryForm.css';

interface CategoryListProps {
  categories: CategoryWithChildren[];
  loading: boolean;
  error: string | null;
  selectedCategoryId?: number;
  onSelectCategory: (category: CategoryWithChildren) => void;
  globalLoading?: boolean;
  loadingMessage?: string;
}

export const CategoryList: React.FC<CategoryListProps> = ({
  categories,
  loading,
  error,
  selectedCategoryId,
  onSelectCategory,
  globalLoading = false,
  loadingMessage = 'Loading...'
}) => {
  if (error) {
    return (
      <div className="list">
        <div className="list-header">
          <h3>Category Types</h3>
        </div>
        <div className="list-items">
          <div className="app-error-message">
            <p>Error loading categories: {error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (loading || globalLoading) {
    return (
      <div className="list">
        <div className="list-header">
          <h3>Category Types</h3>
        </div>
        <div className="list-items">
          <div className="app-loading">
            {loadingMessage}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="list">
      <div className="list-header">
        <h3>Category Types ({categories.length})</h3>
      </div>

      <div className="list-items" role="listbox">
        {categories.length === 0 ? (
          <div className="list-no-items">
            No category types found.
          </div>
        ) : (
          categories.map((category) => (
            <div
              key={category.id}
              className={`list-item ${selectedCategoryId === category.id ? 'selected' : ''}`}
              onClick={() => onSelectCategory(category)}
              role="option"
              tabIndex={0}
              aria-label={`${category.name} categories`}
              aria-selected={selectedCategoryId === category.id}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onSelectCategory(category);
                }
              }}
            >
              <div className="list-item-main-info">
                <div className="list-item-name-section">
                  <div className="list-item-name">{category.name}</div>
                  <div className="list-item-subtitle">
                    {category.children?.length || 0} categories
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};
